import WINDOW from "../../utils/window";

/**
 * Sto the requestAnimationFrame
 */
const stopRaf = () => {
  const raf = /** @type {Number} */ (WINDOW.get("raf"));

  WINDOW.set("raf-running", false);

  cancelAnimationFrame(raf);
};

export default stopRaf;
